import { render, staticRenderFns } from "./CompanyOrders.vue?vue&type=template&id=486faa72&scoped=true&"
import script from "./CompanyOrders.vue?vue&type=script&lang=js&"
export * from "./CompanyOrders.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOrders.vue?vue&type=style&index=0&id=486faa72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486faa72",
  null
  
)

export default component.exports